import moment from 'moment';

export default function formatDate(date: string, format: string) {
  const formattedDate = moment(date).format(format);
  return formattedDate;
}
